// extracted by mini-css-extract-plugin
module.exports = {"root":"equip_root__2TP8J","label_area":"equip_label_area__2iJkc"};